module.exports = __webpack_public_path__ + "static/media/test4.95a473a7.png";